import { Container, IInit } from 'common/container/Container'
import { Observable } from 'rxjs'
import { IStatusService } from 'common/status/StatusService'
import { STATUS_SERVICE_KEY } from 'container/app'
import { IExternalInvitationApi } from 'modules/notifications/api/ExternalInvitationApi'
import { UserDTO } from 'modules/users/models/User'
import { LangType } from 'common/enums/LangType'

type Props = {
  apiKey: symbol
}

export interface IExternalInvitationService extends IInit {
  sendInvitation(mail: string, mailLanguage: LangType): Observable<boolean>

  registerUser(
    user: UserDTO,
    registerToken: string,
    password: string
  ): Observable<UserDTO | undefined>
}

export class ExternalInvitationService implements IExternalInvitationService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IExternalInvitationApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IExternalInvitationApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  sendInvitation(mail: string, mailLanguage: LangType): Observable<boolean> {
    return this._api.sendInvitation(mail, mailLanguage)
  }
  registerUser(
    user: UserDTO,
    registerToken: string,
    password: string
  ): Observable<UserDTO | undefined> {
    return this._api.registerUser(user, registerToken, password)
  }
}
